import { TableCell } from '@/components/Table'
import styles from './ServiceCell.module.css'

interface ServiceCellProps {
  children: string
  detail?: string | null
}

export function ServiceCell({ children, detail }: ServiceCellProps) {
  return (
    <TableCell>
      <div className={styles.service}>{children}</div>
      {detail && <div className={styles.detail}>{detail}</div>}
    </TableCell>
  )
}
